import { render, staticRenderFns } from "./QuizSlider.vue?vue&type=template&id=778cf884&lang=pug&"
import script from "./QuizSlider.vue?vue&type=script&lang=js&"
export * from "./QuizSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports